var React = require('react');

function ReleveInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M84.3 58.2c3.1-5.4 4.7-12.1 4.7-19.9 0-10.1-2.8-17.7-8.4-22.9C75 10.2 67 7.7 56.5 7.7H18.9L0 116.3h30.7l6.9-39.6h4l5.8 39.6h33.9L71 70C76.8 67.5 81.2 63.6 84.3 58.2zM53 51.9c-2.4 1.8-5.1 2.8-8.2 2.8h-3.4l3.5-20.1h4.3c1.5 0 3.1 0.5 4.8 1.5 1.7 1 2.5 3.1 2.5 6.3C56.6 46.9 55.4 50 53 51.9zM158.6 35.9l4.9-28.2h-56.3L88.4 116.3h59.2l4.9-28.7H124l2.3-13.2h23.6l4.4-26.2h-23.6l2.3-12.3H158.6zM210.5 7.7h-32.4l-18.9 108.6h60.4l5.2-29.6h-28.1L210.5 7.7zM368 7.7l-22.9 70h-0.5v-70h-34.4l6.9 108.6h40.7L403.2 7.7H368zM462.2 35.9l4.9-28.2h-56.3L392 116.3h59.2l4.9-28.7h-28.5l2.3-13.2h23.6l4.4-26.2h-23.6l2.3-12.3H462.2zM290.9 7.6L260.5 0l-2.1 7.7h-9.9l-18.9 108.6h59.2l4.9-28.7h-28.5l2.3-13.2h23.6l4.4-26.2H272l2.3-12.3h25.6l4.9-28.2h-13.9L290.9 7.6z"}));
}

ReleveInline.defaultProps = {"viewBox":"0 0 467.1 116.3"};

module.exports = ReleveInline;

ReleveInline.default = ReleveInline;
